import isEmpty from "lodash/isEmpty";
import { createSelector } from "@reduxjs/toolkit";

import { getDummyStoreDetails, getIsPricelessShop } from "@selectors/store";

const defaultObj = {};

type PriceRangeType = { minPrice: number; maxPrice: number };

export const getPricelessProductFetchVariables = createSelector(
  getIsPricelessShop,
  getDummyStoreDetails,
  ({ store }) => store,
  (isPricelessShop: boolean, dummyStoreDetails: PriceRangeType, store: PriceRangeType) => {
    const storeDetails = isEmpty(dummyStoreDetails) ? store : dummyStoreDetails;
    return isPricelessShop
      ? {
          priceKeys: [`${storeDetails?.minPrice}_${storeDetails?.maxPrice}`],
          excludeByoProducts: true,
          excludeTierPricing: true,
          bulkAvailable: false,
        }
      : defaultObj;
  },
);
